import React from 'react';
import {
  Edit,
  SelectInput,
  SimpleFormIterator,
  TextInput,
  NumberInput,
  BooleanInput ,
  ArrayInput,
  DisabledInput,
  TabbedForm,
  FormTab,
  LongTextInput,
  SelectArrayInput,
  AutocompleteArrayInput,
  FormDataConsumer,
  GET_LIST
} from 'react-admin';
import SortableIterator from './ui/SortableIterator';

import restClient from '../services/restClient';
import { appOptions } from '../config/app';

export class ConfigEdit extends React.Component {
  state = {
    categories: [],
    sites: [],
  };

  widget_views = [
    {"id": "widget", "name": "300 x 250"},
    {"id": "widget_large", "name": "Large"},
  ];
  
  slider_types = [
    {"id": "articles", "name": "Top news"},
    {"id": "facebook", "name": "Popular on FB"},
    {"id": "galleries", "name": "Galleries"},
    {"id": "youtube", "name": "Youtube videos"},
  ];
  
  slider_templates = [
    {"id": "1", "name": "3 vertical equal size"},
    {"id": "2", "name": "1 large + 2 smaller"},
  ];
  
  slider_counts = [
    {"id": "1", "name": "1"},
    {"id": "2", "name": "2"},
    {"id": "3", "name": "3"},
  ];

  radio_types = [
    {"id": "tunein", "name": "tunein"},
  ];

  componentDidMount() {
    const apiClient = restClient(appOptions);
    apiClient(GET_LIST, 'articles/categories-choice').then(res => {
      const categories_list = res.data.filter(x => x.id !== 'ignore').map(x => ({'id': +x.id, 'name': x.name}));
      this.setState({ categories: categories_list });
    });

    apiClient(GET_LIST, 'mediasources?size=1000').then(res => {
      const sites_list = res.data.map(x => ({'id': x.id, 'name': x.id}));
      console.log(sites_list);
      this.setState({ sites: sites_list });
    });
  }

  render () {
    console.log(this);
    return (
    <Edit {...this.props}>
      <TabbedForm redirect={false}>
        <FormTab label="Basic">
          <DisabledInput source="id" />
          <TextInput source="title" />
          <TextInput source="title-intro" />
          <TextInput source="author" />
          <TextInput source="base_url" />
          <TextInput source="facebook_app_id" />
          <TextInput source="facebook_page_url" />
          <TextInput source="twitter_name" />
          <TextInput source="version" />


          <NumberInput source="ad_index_l1" />
          <NumberInput source="ad_index_l2" />
        </FormTab>
        <FormTab label="Page sizes">
          <NumberInput source="main_category_top_news_count" />
          <NumberInput source="main_category_sub_news_count" />

          <NumberInput source="google_page_size" />
          <NumberInput source="search_page_size" />
          <NumberInput source="source_posts_page_size" />
          <NumberInput source="cluster_posts_page_size" />
          <NumberInput source="video_posts_page_size" />
          <NumberInput source="facebook_posts_page_size" />
          <NumberInput source="tweets_page_size" />
          <NumberInput source="galleries_page_size" />
          <NumberInput source="latest_news_page_size" />
          <NumberInput source="subcategory_page_size" />

          <NumberInput source="comments_max_items" />
          <NumberInput source="galleries_max_items" />
          <NumberInput source="latest_news_max_items" />
        </FormTab>
        <FormTab label="Footer">
          <ArrayInput source="footer.categories" className="fullwidth-form" label="">
              <SortableIterator keyName="link">
                <TextInput source="type" />
                <TextInput source="name" />
                <TextInput source="link" />
                <TextInput source="meta_title" />
                <TextInput multiline source="meta_description" />
                <BooleanInput source="hide" />
                <BooleanInput source="open_in_new_tab" />
              </SortableIterator>
            </ArrayInput>
        </FormTab>
        <FormTab label="Widgets">
          <ArrayInput source="widgets" className="fullwidth-form" label="">
              <SimpleFormIterator keyName="url">
                <TextInput source="name" />
                <TextInput source="url" />
                <TextInput source="background" />
                <SelectInput label="type" source="view" choices={this.widget_views} />
                <NumberInput source="news_count" />
                <SelectArrayInput source="categories" choices={this.state.categories} />
              </SimpleFormIterator>
            </ArrayInput>
        </FormTab>
        
        <FormTab label="Air Quality">
          <FormDataConsumer>
          {({ formData, ...rest }) => formData.air_quality && formData.air_quality.url ?
          <div>
            <LongTextInput source="air_quality.url" />
            <BooleanInput source="show" />
            <ArrayInput source="air_quality.regions" className="inline-form" label="">
              <SimpleFormIterator>
                <TextInput />
              </SimpleFormIterator>
            </ArrayInput>
          </div> :
          <div>
            <p>N/A</p>
          </div>
          }
          </FormDataConsumer>
        </FormTab>
        
        <FormTab label="Top Slider">
          <FormDataConsumer>
            {({ formData, ...rest }) => formData.slider && formData.slider.slides && formData.slider.slides.length ?
              <div>
                <AutocompleteArrayInput label="Hide sites from all slides" source="slider.ignore_sites" choices={this.state.sites} />
                <ArrayInput source="slider.slides" className="fullwidth-form" label="">
                  <SortableIterator keyName="title">
                    <TextInput source="title" />
                    <SelectInput source="count" choices={this.slider_counts} />
                    <SelectInput source="type" choices={this.slider_types} />
                    <SelectInput source="template" choices={this.slider_templates} allowEmpty={true} />
                    <SelectArrayInput source="categories" choices={this.state.categories} />
                    <AutocompleteArrayInput label="Hide sites from slide" source="ignore_sites" choices={this.state.sites} />
                    <BooleanInput label="Homepage only" source="main" />
                  </SortableIterator>
                </ArrayInput>
              </div> :
              <div>
                <NumberInput source="top_slider_min_news_count" />
                <NumberInput source="top_slider_max_news_count" />
              </div>
            }
          </FormDataConsumer>
        </FormTab>
        <FormTab label="Radios">
          <TextInput source="radios.name" />
          <TextInput source="radios.menu" />
          <TextInput source="radios.link" />
          <ArrayInput source="radios.categories" className="fullwidth-form" label="">
            <SortableIterator keyName="link">
              <TextInput source="name" />
              <TextInput source="link" />
              <ArrayInput source="stations" className="inline-form" label="">
                <SortableIterator keyName="link">
                  <TextInput source="name" />
                  <TextInput source="link" />
                  <SelectInput source="type" choices={this.radio_types} />
                  <TextInput source="e_id" />
                </SortableIterator>
              </ArrayInput>
            </SortableIterator>
          </ArrayInput>
        </FormTab>
        <FormTab label="Categories order">
          <ArrayInput source="categories" className="inline-form" label="">
            <SortableIterator keyName="id" disableAdd disableRemove>
              <DisabledInput source="name" />
              <ArrayInput source="subcategories" className="inline-form" label="">
                <SortableIterator keyName="id" disableAdd disableRemove>
                  <DisabledInput source="name" />
                </SortableIterator>
              </ArrayInput>
            </SortableIterator>
          </ArrayInput>
        </FormTab>
      </TabbedForm>
    </Edit>
    );
  }
}



// WEBPACK FOOTER //
// ./src/resources/config.js